export enum CompanyActionType {
    UserSettings = 'UserSettings',
}
